import { render, staticRenderFns } from "./EditorComponent.vue?vue&type=template&id=2a662a50&scoped=true&"
import script from "./EditorComponent.vue?vue&type=script&lang=js&"
export * from "./EditorComponent.vue?vue&type=script&lang=js&"
import style0 from "./EditorComponent.vue?vue&type=style&index=0&id=2a662a50&scoped=true&lang=scss&"
import style1 from "./EditorComponent.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a662a50",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VCol,VRow,VSelect})
